import { walletAddressTypeImage } from "@lib/helpers/ColorHelper";
import { createYupSync } from "@lib/helpers/TableHelper";
import { walletAddressSchema as yupSchema } from "@lib/schemas/wallet";
import {
  WalletAddressCreationType,
  WalletAddressStatus,
} from "@lib/types/Billing";
import { SendByteWalletAddressCreationType } from "@lib/types/SendByte";
import { Form, Input } from "antd";
import TextArea from "antd/es/input/TextArea";
import { FormInstance } from "antd/lib";
import { FaQuestion } from "react-icons/fa";
import { useIntl } from "react-intl";

type Props = {
  creationType: WalletAddressCreationType | SendByteWalletAddressCreationType;
  form: FormInstance<any>;
  loading: boolean;
  walletAddressId?: string;
};

export default function WalletAddressInput(props: Props) {
  const { creationType, form, loading, walletAddressId } = props;
  const { messages } = useIntl();
  const walletId = Form.useWatch("walletId", form);
  const status = Form.useWatch("status", form);
  const network = Form.useWatch("network", form);

  if (status === WalletAddressStatus.InUse && walletAddressId) {
    return (
      <Form.Item
        name="address"
        rules={[createYupSync({ schema: yupSchema, formData: { network } })]}
        label={messages["common.walletAddress"] as string}
      >
        <Input
          variant="borderless"
          disabled={true}
          prefix={
            <img
              src={walletAddressTypeImage(network)}
              style={{ width: "15px", height: "15px" }}
            />
          }
        />
      </Form.Item>
    );
  }

  return (
    <Form.Item
      name="address"
      rules={[createYupSync({ schema: yupSchema, formData: { network } })]}
      label={messages["common.walletAddress"] as string}
    >
      {creationType == WalletAddressCreationType.MULTIPLE ? (
        <TextArea allowClear disabled={loading || !walletId} rows={6} />
      ) : (
        <Input
          allowClear
          disabled={loading || !walletId}
          prefix={
            walletAddressTypeImage(network) ? (
              <img
                src={walletAddressTypeImage(network)}
                style={{ width: "15px", height: "15px" }}
              />
            ) : (
              <FaQuestion />
            )
          }
        />
      )}
    </Form.Item>
  );
}
